module.exports = __webpack_public_path__ + "static/media/logo-workable.5c387194.png";